import { render } from "./DColumnTitle.vue?vue&type=template&id=56f43970&scoped=true"
import script from "./DColumnTitle.vue?vue&type=script&lang=js"
export * from "./DColumnTitle.vue?vue&type=script&lang=js"

import "./DColumnTitle.vue?vue&type=style&index=0&id=56f43970&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56f43970"]])

export default __exports__